const state = {
    friendsList: [],
};
const getters = {
    friendsList: (state) => state.friendsList,
};
const actions = {
    getFriends({commit}, data){
        commit("SET_FRIENDS_LIST", data);
    }
};
const mutations = {
    SET_FRIENDS_LIST(state, friendsList){
        state.friendsList = friendsList;
    }
};

export default {
  state,
  getters,
  actions,
  mutations,
};
